import { useTranslation } from 'react-i18next'

import { UploadImage } from '@reveni-io/reveni-ui'

import { literalTranslationOptions } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/TrackingPagePreview/constants'

const BlockSettingImageField = ({ field, value, onChange, onUploadImage, canUploadImage }) => {
  const { t } = useTranslation()

  const handleUpload = async file => {
    const imageUrl = await onUploadImage(file)

    if (!imageUrl) throw new Error('The block image could not be uploaded')
  }

  const handleDelete = () => onChange(field.key, '')

  return (
    <UploadImage
      buttonText={t(field.label, literalTranslationOptions)}
      recommendation={t(field.helper, literalTranslationOptions)}
      accept={field.accept}
      maxSize={field.maxSize}
      defaultImage={value}
      onChange={handleUpload}
      onDelete={handleDelete}
      disabled={!canUploadImage}
    />
  )
}

export default BlockSettingImageField
